
import { jsonp } from '@/libs/network.js';
import platform from '@/libs/platform.js';
import AppHeader from '@/components/AppHeader/index.vue'
import SubHeader from '@/components/SubHeader/index.vue';
import AppFooter from '@/components/AppFooter/index.vue'
import GoTop from '@inotom/vue-go-top';

export default {
  name: 'detail',
  metaInfo: {
    title: '金融城 CFCITY'
  },
  components: {
    AppHeader,
    SubHeader,
    AppFooter,
    GoTop
  },
  data () {
    return {
      pid: this.$route.params.id,
      sub: this.$route.params.sub,
      detail: {}, //文章
      module: [] // 1一行三列 2一行一列 3单图片
    }
  },
  mounted() {
    console.log(`detail 路由: ${this.$route.params.id}`);
    if( platform.ismobile ){

      console.log('h5 mounted detail')

    }else{

      console.log('pc mounted detail')

    }
    let self = this;
    jsonp('/newsInfo', {
      'callback': 'detail',
      'news_id': self.pid
    }).then(res => {
      let _d = res.data;
      self.detail = _d.news_info;
      self.module = _d.module_list;
    }, err => {
      console.log(err);
    })
  },
  methods: {
    handleToggleDrawer () {
      this.$refs.drawerLayout.toggle();
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.isMobile
    },
    isIphone () {
      return this.$store.state.isIphone
    },
    navBarFixed () {
      return this.$store.state.navBarFixed
    }

  }
}
